<template>
    <p :class="finalClasses">
        <slot />
    </p>
</template>

<script>
export default {
    name: 'BaseParagraphe',
    props: {
        /**
         * Contenu texte du paragraphe (optionnel si slot utilisé)
         */
        text: {
            type: String,
            default: '',
        },
        /**
         * Classes supplémentaires à ajouter.
         */
        customClass: {
            type: String,
            default: '',
        },
        /**
         * Si true, supprime les classes par défaut.
         */
        noDefault: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        finalClasses() {
            const base = 'ppv2-flex ppv2-items-center ppv2-space-x-2 ppv2-mt-1 ppv2-text-xs ppv2-text-gray-500'
            return this.noDefault ? this.customClass : `${base} ${this.customClass}`.trim()
        },
    },
}
</script>

<style scoped></style>
